module.exports = "https://www.gc-pro.gnp.com.mx/d28206af827db4ac5edd746c634bd6e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Banner_PortalSoyCliente-01.png
// module id = 8047
// module chunks = 0